import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=f497f62a&scoped=true&"
import script from "./simple.vue?vue&type=script&lang=js&"
export * from "./simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f497f62a",
  null
  
)

export default component.exports